import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { SocialTemplate } from "../../interface/social";

@Component({
  selector: "app-template",
  templateUrl: "./template.component.html",
  styleUrls: ["./template.component.scss"],
})
export class TemplateComponent implements OnInit {
  private _template: SocialTemplate;
  @Input() isTemplateModal: boolean;
  @Input() index: number;
  @Input() isSettings: boolean = false;
  @Input() hideDelete: boolean = false;
  @Input() isInteractRhs: boolean = false;
  @Input() isDefaultTemplate: boolean | null = false;
  @Input() hideContent: boolean = false;
  @Input() isReviewTemplate: boolean;
  @Input() isZceppaTemplateSection: boolean;
  @Output() public onDeleteTemplate: EventEmitter<string> =
    new EventEmitter<string>();
  @Input() feature:
    | "social"
    | "messaging"
    | "reply"
    | "appointment"
    | "mystore";
  @Input()
  set template(value) {
    this._template = value;
  }
  get template() {
    return this._template;
  }
  private _selectedTemplate: SocialTemplate;
  @Input()
  set selectedTemplate(value) {
    this._selectedTemplate = value;
  }
  get selectedTemplate() {
    return this._selectedTemplate;
  }
  @Input() isMultiOutlet: boolean = false;
  constructor() {}

  ngOnInit() {}

  onDeleteTemplateAction(templateID: string) {
    this.onDeleteTemplate.emit(templateID);
  }

  isNewTemplate(createdAt: moment.MomentInput) {
    const createDate =
      createdAt && moment(createdAt).isAfter(moment().subtract(1, "month"));
    return createDate || false;
  }
}
